var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteCloseContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-174.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-close-content",
    transform: "translate(174.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    stroke: "#B2C1DF",
    cx: 13,
    cy: 13,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,8 C13.2761424,8 13.5,8.22385763 13.5,8.5 L13.5,12.5 L17.5,12.5 C17.7761424,12.5 18,12.7238576 18,13 C18,13.2761424 17.7761424,13.5 17.5,13.5 L13.5,13.5 L13.5,17.5 C13.5,17.7761424 13.2761424,18 13,18 C12.7238576,18 12.5,17.7761424 12.5,17.5 L12.5,13.5 L8.5,13.5 C8.22385763,13.5 8,13.2761424 8,13 C8,12.7238576 8.22385763,12.5 8.5,12.5 L12.5,12.5 L12.5,8.5 C12.5,8.22385763 12.7238576,8 13,8 Z",
    id: "Combined-Shape",
    fill: "#B2C1DF",
    transform: "translate(13.000000, 13.000000) rotate(45.000000) translate(-13.000000, -13.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteCloseContent);
export default __webpack_public_path__ + "static/media/icon-rte-close-content.8aad887819c0b73716099256171c05ee.svg";
export { ForwardRef as ReactComponent };